import { TABS } from "../../constants";

export function AppTitle({ appMode, setAppMode }) {
  const handleModeChange = (nextMode) => {
    setAppMode(nextMode);
  };

  return (
    <div className="motion-app-title app-title">
      <h1 className="app-title__heading">
        orion33
      </h1>
      <div className="mode-switch" aria-label="Selecionar versão">
        <button
          type="button"
          className={
            appMode === "complete"
              ? "mode-switch__button active"
              : "mode-switch__button"
          }
          onClick={() => handleModeChange("complete")}
        >
          <span className="mode-switch__label">Completo</span>
        </button>
        <button
          type="button"
          className={
            appMode === "simple"
              ? "mode-switch__button active"
              : "mode-switch__button"
          }
          onClick={() => handleModeChange("simple")}
        >
          <span className="mode-switch__label">Simplificado</span>
        </button>
      </div>
    </div>
  );
}

export function CompleteTabs({ tab, setTab, tournamentModal, registroModal }) {
  const activeIndex = Math.max(TABS.indexOf(tab), 0);
  const handleTabChange = (nextTab) => {
    setTab(nextTab);
    tournamentModal.close();
    registroModal.close();
  };

  return (
    <div className={`complete-tabs complete-tabs--active-${activeIndex}`}>
      {TABS.map((t) => (
        <button
          key={t}
          className={`tab-btn ${tab === t ? "tab-active" : "tab-inactive"}`}
          onClick={() => handleTabChange(t)}
        >
          {t}
        </button>
      ))}
    </div>
  );
}
